module.exports = __webpack_public_path__ + "media/images/AmyPfN9k-4b7081ae275da20561de26c4e3d482ee.jpeg";